import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface HelpPanelProps {
    title: string;
    content: React.ReactNode;
    onClose: () => void;
}

function HelpPanel({ title, content, onClose }: HelpPanelProps) {
    return (
        <Box sx={{ 
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            p: 2
        }}>
            <Box sx={{ 
                mb: 2,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <Typography 
                    variant="h6" 
                    color="primary"
                    sx={{ fontWeight: 'bold' }}
                >
                    {title}
                </Typography>
                
                <IconButton
                    onClick={onClose}
                    size="small"
                    sx={{
                        color: 'text.secondary',
                        '&:hover': {
                            bgcolor: 'rgba(53, 70, 162, 0.04)'
                        }
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>

            <Box sx={{ 
                flex: 1,
                overflowY: 'auto'
            }}>
                {content}
            </Box>
        </Box>
    );
}

export default HelpPanel;
